// Damaging move data for all moves used by competitive Pokémon.
// Names match Showdown / @smogon/calc format exactly.
// basePower: null = weight-based (Heavy Slam, Heat Crash) — @smogon/calc handles natively.
// hits: multi-hit count (Surging Strikes, Dragon Darts etc.)
// isSpread: true = hits multiple targets in doubles (×0.75 penalty when toggled)

export const MOVE_DATA = {
  // ── Normal ──────────────────────────────────────────────────────────────
  'Extreme Speed':     { type: 'Normal',    category: 'Physical', basePower: 80 },
  'Hyper Voice':       { type: 'Normal',    category: 'Special',  basePower: 90,  isSpread: true },
  'Boomburst':         { type: 'Normal',    category: 'Special',  basePower: 140, isSpread: true },
  'Fake Out':          { type: 'Normal',    category: 'Physical', basePower: 40 },
  'U-turn':            { type: 'Bug',       category: 'Physical', basePower: 70 },

  // ── Fire ────────────────────────────────────────────────────────────────
  'Fire Blast':        { type: 'Fire',      category: 'Special',  basePower: 110 },
  'Flamethrower':      { type: 'Fire',      category: 'Special',  basePower: 90 },
  'Heat Wave':         { type: 'Fire',      category: 'Special',  basePower: 95,  isSpread: true },
  'Overheat':          { type: 'Fire',      category: 'Special',  basePower: 130 },
  'Torch Song':        { type: 'Fire',      category: 'Special',  basePower: 80 },
  'Sacred Fire':       { type: 'Fire',      category: 'Physical', basePower: 100 },
  'Flare Blitz':       { type: 'Fire',      category: 'Physical', basePower: 120 },
  'Mystical Fire':     { type: 'Fire',      category: 'Special',  basePower: 75 },
  'Fire Fang':         { type: 'Fire',      category: 'Physical', basePower: 65 },
  'Heat Crash':        { type: 'Fire',      category: 'Physical', basePower: null }, // weight-based

  // ── Water ───────────────────────────────────────────────────────────────
  'Water Spout':       { type: 'Water',     category: 'Special',  basePower: 150, isSpread: true },
  'Origin Pulse':      { type: 'Water',     category: 'Special',  basePower: 110, isSpread: true },
  'Hydro Pump':        { type: 'Water',     category: 'Special',  basePower: 110 },
  'Hydro Steam':       { type: 'Water',     category: 'Special',  basePower: 80 },
  'Muddy Water':       { type: 'Water',     category: 'Special',  basePower: 90,  isSpread: true },
  'Aqua Jet':          { type: 'Water',     category: 'Physical', basePower: 40 },
  'Surging Strikes':   { type: 'Water',     category: 'Physical', basePower: 25,  hits: 3 },

  // ── Electric ────────────────────────────────────────────────────────────
  'Thunderbolt':       { type: 'Electric',  category: 'Special',  basePower: 90 },
  'Thunder':           { type: 'Electric',  category: 'Special',  basePower: 110 },
  'Discharge':         { type: 'Electric',  category: 'Special',  basePower: 80,  isSpread: true },
  'Wild Charge':       { type: 'Electric',  category: 'Physical', basePower: 90 },
  'Thunder Punch':     { type: 'Electric',  category: 'Physical', basePower: 75 },
  'Electro Drift':     { type: 'Electric',  category: 'Special',  basePower: 100 },

  // ── Grass ───────────────────────────────────────────────────────────────
  'Energy Ball':       { type: 'Grass',     category: 'Special',  basePower: 90 },
  'Giga Drain':        { type: 'Grass',     category: 'Special',  basePower: 75 },
  'Leaf Storm':        { type: 'Grass',     category: 'Special',  basePower: 130 },
  'Wood Hammer':       { type: 'Grass',     category: 'Physical', basePower: 120 },
  'Flower Trick':      { type: 'Grass',     category: 'Physical', basePower: 70 },
  'Grassy Glide':      { type: 'Grass',     category: 'Physical', basePower: 60 },
  'Pollen Puff':       { type: 'Bug',       category: 'Special',  basePower: 90 },

  // ── Ice ─────────────────────────────────────────────────────────────────
  'Ice Beam':          { type: 'Ice',       category: 'Special',  basePower: 90 },
  'Blizzard':          { type: 'Ice',       category: 'Special',  basePower: 110, isSpread: true },
  'Freeze-Dry':        { type: 'Ice',       category: 'Special',  basePower: 70 },
  'Ice Shard':         { type: 'Ice',       category: 'Physical', basePower: 40 },
  'Ice Punch':         { type: 'Ice',       category: 'Physical', basePower: 75 },
  'Glacial Lance':     { type: 'Ice',       category: 'Physical', basePower: 120, isSpread: true },
  'Ice Spinner':       { type: 'Ice',       category: 'Physical', basePower: 80 },
  'Icicle Crash':      { type: 'Ice',       category: 'Physical', basePower: 85 },

  // ── Fighting ────────────────────────────────────────────────────────────
  'Close Combat':      { type: 'Fighting',  category: 'Physical', basePower: 120 },
  'Sacred Sword':      { type: 'Fighting',  category: 'Physical', basePower: 90 },
  'Drain Punch':       { type: 'Fighting',  category: 'Physical', basePower: 75 },
  'Focus Blast':       { type: 'Fighting',  category: 'Special',  basePower: 120 },
  'Collision Course':  { type: 'Fighting',  category: 'Physical', basePower: 100 },
  'High Horsepower':   { type: 'Ground',    category: 'Physical', basePower: 95 },
  'Headlong Rush':     { type: 'Ground',    category: 'Physical', basePower: 100 },

  // ── Poison ──────────────────────────────────────────────────────────────
  'Sludge Wave':       { type: 'Poison',    category: 'Special',  basePower: 95,  isSpread: true },
  'Sludge Bomb':       { type: 'Poison',    category: 'Special',  basePower: 90 },

  // ── Ground ──────────────────────────────────────────────────────────────
  'Earthquake':        { type: 'Ground',    category: 'Physical', basePower: 100, isSpread: true },
  'Precipice Blades':  { type: 'Ground',    category: 'Physical', basePower: 120, isSpread: true },

  // ── Flying ──────────────────────────────────────────────────────────────
  'Brave Bird':        { type: 'Flying',    category: 'Physical', basePower: 120 },
  'Aeroblast':         { type: 'Flying',    category: 'Special',  basePower: 100 },
  'Air Slash':         { type: 'Flying',    category: 'Special',  basePower: 75 },

  // ── Psychic ─────────────────────────────────────────────────────────────
  'Psychic':           { type: 'Psychic',   category: 'Special',  basePower: 90 },
  'Psyshock':          { type: 'Psychic',   category: 'Special',  basePower: 80 }, // targets Def
  'Expanding Force':   { type: 'Psychic',   category: 'Special',  basePower: 80 }, // 1.5× in Psychic Terrain
  'Future Sight':      { type: 'Psychic',   category: 'Special',  basePower: 120 },

  // ── Bug ─────────────────────────────────────────────────────────────────
  'Bug Buzz':          { type: 'Bug',       category: 'Special',  basePower: 90 },

  // ── Rock ────────────────────────────────────────────────────────────────
  'Rock Slide':        { type: 'Rock',      category: 'Physical', basePower: 75,  isSpread: true },
  'Stone Edge':        { type: 'Rock',      category: 'Physical', basePower: 100 },
  'Power Gem':         { type: 'Rock',      category: 'Special',  basePower: 80 },
  'Meteor Beam':       { type: 'Rock',      category: 'Special',  basePower: 120 },

  // ── Ghost ───────────────────────────────────────────────────────────────
  'Shadow Ball':       { type: 'Ghost',     category: 'Special',  basePower: 80 },
  'Astral Barrage':    { type: 'Ghost',     category: 'Special',  basePower: 120, isSpread: true },
  'Moongeist Beam':    { type: 'Ghost',     category: 'Special',  basePower: 100 },
  'Wicked Blow':       { type: 'Dark',      category: 'Physical', basePower: 80 },

  // ── Dragon ──────────────────────────────────────────────────────────────
  'Dragon Pulse':      { type: 'Dragon',    category: 'Special',  basePower: 85 },
  'Draco Meteor':      { type: 'Dragon',    category: 'Special',  basePower: 130 },
  'Dragon Claw':       { type: 'Dragon',    category: 'Physical', basePower: 80 },
  'Dragon Darts':      { type: 'Dragon',    category: 'Physical', basePower: 50,  hits: 2 },

  // ── Dark ────────────────────────────────────────────────────────────────
  'Dark Pulse':        { type: 'Dark',      category: 'Special',  basePower: 80 },
  'Crunch':            { type: 'Dark',      category: 'Physical', basePower: 80 },
  'Sucker Punch':      { type: 'Dark',      category: 'Physical', basePower: 70 },
  'Knock Off':         { type: 'Dark',      category: 'Physical', basePower: 65 },
  'Kowtow Cleave':     { type: 'Dark',      category: 'Physical', basePower: 85 },
  'Snarl':             { type: 'Dark',      category: 'Special',  basePower: 55,  isSpread: true },

  // ── Steel ───────────────────────────────────────────────────────────────
  'Iron Head':         { type: 'Steel',     category: 'Physical', basePower: 80 },
  'Make It Rain':      { type: 'Steel',     category: 'Special',  basePower: 120, isSpread: true },
  'Heavy Slam':        { type: 'Steel',     category: 'Physical', basePower: null }, // weight-based
  'Behemoth Blade':    { type: 'Steel',     category: 'Physical', basePower: 100 },
  'Behemoth Bash':     { type: 'Steel',     category: 'Physical', basePower: 100 },

  // ── Fairy ───────────────────────────────────────────────────────────────
  'Moonblast':         { type: 'Fairy',     category: 'Special',  basePower: 95 },
  'Dazzling Gleam':    { type: 'Fairy',     category: 'Special',  basePower: 80,  isSpread: true },
  'Play Rough':        { type: 'Fairy',     category: 'Physical', basePower: 90 },
  'Spirit Break':      { type: 'Fairy',     category: 'Physical', basePower: 75,  isSpread: true },
  'Draining Kiss':     { type: 'Fairy',     category: 'Special',  basePower: 50 },
};

// Moves that are status / non-damaging (filtered out from condition pickers)
export const STATUS_MOVES = new Set([
  'Dragon Dance', 'Swords Dance', 'Nasty Plot', 'Quiver Dance', 'Bulk Up',
  'Calm Mind', 'Will-O-Wisp', 'Spore', 'Rage Powder', 'Clear Smog',
  'Trick Room', 'Encore', 'Perish Song', 'Recover', 'Parting Shot',
  'Tail Wind', 'Protect', 'Follow Me', 'Helping Hand',
]);

// All damaging move names for broad dropdown
export const ALL_MOVE_NAMES = Object.keys(MOVE_DATA).sort();
